module.exports = __webpack_public_path__ + "img/teach_friends_register.92a2fd79.png";